import mock from 'src/utils/mock';
import { Employee as EmployeeInterface, EmployeeDetailType } from 'src/types/employee';
const employee: EmployeeInterface[] = [
    {
        EmpCode: '701',
        Emp_First_Name: 'Rakesh',
        Emp_Middle_Name: 'Kumar',
        Emp_Last_Name: 'Sharma',
        DesignationCode: 'Junior',
        Emp_EmailID: 'rakeshk@gmail.com',
        Emp_DOJ: '2008-09-01T00:00:00.000Z',
        Emp_Department: 'Information Tec',
        Emp_Phone1: '9855404659',
        Emp_Father_Husband_Name: '',
        Emp_Relation_With: 'Father',
    },
];

const employeeDetail: EmployeeDetailType[] = [
    {
        EmpCode: '701',
        AutoID_As_EmpCode: 'Y',
        First_Name: 'Rakesh',
        Middle_Name: 'Kumar',
        Last_Name: 'Sharma',
        MaritialStatus: 'Married',
        Gender: 'M',
        Fth_Hsb_Name: 'Suresh Kumar Sharma',
        RelationWith: 'Father',
        DOB: '1983-04-01T00:00:00.000Z',
        Phone1: '9855404659',
        Phone2: '',
        DesignationCode: 'Junior',
        Title: 'Mr.',
        EmailID: 'rakeshk@gmail.com',
        DOJ: '2008-09-01T00:00:00.000Z',
        Department: 'Information Tec',
        Flag1: ' ',
        Flag2: ' ',
        Flag1_Comment: '',
        Flag2_Comment: '',
        OtherID: '2885',
        PunchCardID: 1,
    },
];

mock.onPost('/getemp/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, employee]);
        }, 1000);
    });
});
mock.onPost('/getempDetail/').reply((config) => {
    const params = JSON.parse(config.data);
    const idAsString = params.id.toString();
    const employData = employeeDetail.filter((item) => item.EmpCode === idAsString)[0];
    return [200, { ...employData }];
});
